import { Image, Article, Section, DocsIntro, DocsHeader, SectionHeader } from '../extra/Components';

import introImgSmall from '../assets/1 intro/intro1-small.jpg';
import introImg from '../assets/1 intro/intro1.jpg';

import hoppImg from '../assets/1 intro/2 hopp.jpg';
import hoppImgSmall from '../assets/1 intro/2 hopp-small.jpg';

import aff from '../assets/1 intro/3 affintro2.png'
import affSmall from '../assets/1 intro/3 affintro2-small.jpg'
import { Questionary, Question } from '../extra/Quiz';

import {
    faMapSigns
} from "@fortawesome/free-solid-svg-icons";

const introQuiz = [
    Question.oneQ("När måste licensen förnyas", "1e january varje år", ["Aldrig", "Ett år efter man betalat licensavgift"]),
    //Question.oneQ("Det krävs fullt färgseende för att hoppa fallskärm", "Nej (inte sen 2022)", ["Ja"]),
    Question.oneQ("ADHD är sannolikt diskvalificerande för att ta fallskärmslicens", "Ja", ["Nej"]),
    Question.oneQ("Vem överser civil fallskärmshoppning i Sverige", "RI", ["Den lokala CI", "Kursledare"]),
    Question.oneQ("Har jag klagomål på min Kursledare bör jag kontakta", "Den lokala CI", ["RI", "Andra Kursledare"]),
]

const Intro = ({setSection, setArticle}) => (
    <Article name="Inledning" icon={faMapSigns} id="introduktion" setArticle={setArticle} setSection={setSection}>
        <DocsHeader >
            <h1 className="docs-heading">Börja hoppa fallskärm! <span className="docs-time">Last updated:
                2022-07-16</span>
            </h1>

            <Image imageSmall={introImgSmall} image={introImg} />


            <br />
            <DocsIntro>
                <br />
                <p>Innan man börjar hoppa fallskärm behöver man bakgrundskunskap om hur hoppet ska
                    genomföras och varför.
                    Varje hopp man som fallskärmshoppare gör består av en serie olika moment som ska
                    genomföras på rätt sätt. I den här manualen kommer vi gå igenom dessa;</p>
                <ul>
                    <li>Förberedelser på marken</li>
                    <li>Transport till uthoppshöjd</li>
                    <li>Uthopp</li>
                    <li>Frifall</li>
                    <li>Drag av fallskärm</li>
                    <li>Flygning av fallskärm</li>
                    <li>Landning</li>
                </ul>
                {/** <p>Det här är en manual för den bakgrundskunskap man behöver göra ett solo fallskärmshopp.
                                Den beskriver de olika moment som är involverade och de kunskaper som förväntas. Denna
                                text är inte komplett och bör användas som komplement till praktisk utbildning.</p> **/}

            </DocsIntro>
        </DocsHeader>
        {/**<section className="docs-section" id="vad">
                        <h2 className="section-heading">Vad är fallskärmshoppning?</h2>
                        <p></p>
                        <p>Fallskärmshoppning är kort att hoppa från luftfarkost med fallskärm. Fallskärmshoppning har
                            funnits i olika former sen luftballongerna uppfanns. Under andra världskriget fick det sig
                            ett uppsving av det militära användandet. Det har sedan dess spridit sig till hoppning för
                            nöjes skull som vi fokuserar på här. Ett fallskärmshopp består av en serie delar som vi
                            kommer diskutera här, förberedelser på marken, flygningen till höjd, uthopp, frifall, drag,
                            flygningen av fallskärmen och landningen </p>
                    </section>  */}
        <Section id="krav" name="Krav" >
            <SectionHeader>Krav för att få ta fallskärmslicens</SectionHeader>

            <Image imageSmall={hoppImgSmall} image={hoppImg} />


            <br /><br />
            <p>Fallskärmshoppning är en väldigt reglerad sport och följer under flera internationella avtal
                om flygsäkerhet. När man flyger en fallskärm klassas som att vara pilot.</p>
            <p>För att få hoppa fallskärm i Sverige måste nedanstående kriterier uppfyllas.</p>
            <ul>
                <li><strong>Fungerande axlar</strong>: rörlighet och inga skador som gör det lättare att få
                    axel ur led. (T.ex. ej opererad tidigare luxation)</li>
                {/** <!--<li><strong>Fungerande axlar</strong>: fri från axelskador (ej opererad axelluxation är
                                diskvalificerande)</li>-->
                            <li><strong>God syn</strong>: Minimumkrav är: 0.7 syn på vardera öga och 1.0 binokulärt</li>
                            <!--<li><strong>Fullgott färgseende</strong>: 11 rätt på tavlorna 2-15 i Ishihara
                                <strong>(Upphörde 2022)</strong> --> 
                            </li>**/}
                <li><strong>Full rörlighet</strong>:
                    <ul>
                        <li>Kan stiga upp på stol med ett ben.</li>
                        <li>Kan sitta på huk så fingrar når golvet.</li>
                        <li>Kan lyfta armar rakt upp framåt och bakåt.</li>
                        <li>Kan lägga handryggen på ryggens medellinje ovan midjan.</li>
                    </ul>
                </li>
                <li><strong>Fri från epilepsi</strong>: krampfri i tio år utan behandling.</li>
                <li><strong>Fri från ADHD</strong>: Personer med ADHD får enligt flygmedicinska bestämmelser
                    inte bli pilot.</li>
            </ul>
            <p>Mer information om de specifika medicinska kraven finns på <a
                href="http://www.sff.se/index.php/medicinska-fragor">sffs hemsida: Medicinska frågor</a>
            </p>
            <p>Innan första hoppet ska medicinsk tjänstbarhetsbedömning vara gjord. Blanketten
                finns på <a href="http://www.sff.se/index.php/lakarundersokning">sffs hemsida:
                    Läkarundersökning</a></p>
        </Section>
        <Section id="affintro" name="AFF"  >
            <SectionHeader >AFF</SectionHeader>
            <p><b>AFF</b>, <i>Accelererat frifall</i>, är den vanligaste frifallsutbildningsformen för
                fallskärmshoppning. En AFF-utbildning består utav tio fallskärmshopp. Eleven genomför första
                sju hoppen tillsammans med aff-instruktör(er). De tre sista hoppen i utbildningen utförs
                självständigt under uppsyn av instruktör. Varje hopp i utbildningen består av ett antal
                olika moment som ska utföras och godkännas innan man går vidare till nästa.
                Utöver AFF finns även utbildningsformerna SFU och konventionell. Dessa utbildningsformer
                behandlas inte i denna manual.</p>

            <Image imageSmall={affSmall} image={aff} />

        </Section>
        <Section id="sff" name="Svenska fallskärmsförbundet"  >
            <SectionHeader >Svenska fallskärmsförbundet</SectionHeader>
            <p>Svenska fallskärmsförbundet (SFF) är den ideella organisation som ansvarar för
                fallskärmshoppning i Sverige. Det är en ideell organisation som lyder under
                transportstyrelsen. Svenska fallskärmsförbundet reglerar fallskärmshoppningen i Sverige med
                två primära dokument, <a
                    href="https://www.sff.se/index.php/fakta-for-hoppare/hopparens-regler-sbf"><i>Svenska
                        bestämmelse fallskärmshoppning</i>(SBF)</a> samt
                <a href="http://www.sff.se/index.php/materielhandboken"><i>materialhandboken</i></a>.
            </p>
            <p>Riksinstruktören (RI) överser den civila fallskärmsverksamheten i Sverige. På varje lokal
                klubb
                I varje lokal klubb finns en chefsinstruktör (CI) som ansvarar för utbildnings och
                säkerhetsarbetet samt för hoppverksamheten.</p>
            <p>Under din utbildning kommer du träffa på olika instruktörer. Kursledare (KL) håller i
                markkursen och AFF-instruktörer (AFF) håller i frifallsutbildningen. Många gånger kan
                samma personer ha båda befogenheter.</p>
            <p>För att hoppa fallskärm i Sverige så måste man vara medlem i SFF.
                Medlemsåret är januari till december och medlemskapet måste därefter förnyas.</p>
        </Section>
        <Section id="kostnad" name="Kostnad"  >
            <SectionHeader >Kostnad</SectionHeader>
            {/** <!-- Här med Elin --> **/}
            <p>Fallskärmshoppning är en dyr sport. Avgiften man betalar för grundkursen innefattar i regel
                teoriutbildningen, utbildningshoppen och rigg-hyra under utbildningshoppen. Packningar under
                utbildning ingår ej däremot lär du dig att packa din egen fallskärm.</p>
            <p>Vill man inte packa själv så finns det oftast folk på plats som är villiga att packa
                fallskärmar mot betalning. Typiskt kostar det ca 80 kronor att få en elevfallskärm packad.
            </p>
            <p>När man är licensierad hoppare kostar i en plats i flygplanet ca 200 kronor. Till det
                tillkommer rigg-hyra på ca 100 kronor per hopp om man inte har egen.</p>
            <p>Vill man köpa fallskärm efter kursen så börjar i regel begagnade utrustningar på ca 25-30 000
                kronor
                men behåller värdet ganska bra. Ny utrustning kan gå upp emot 60-70 000 kronor. Var man
                hamnar i
                intervallet beror på hur ny utrustning man vill ha och vad som finns tillgängligt på
                begagnatmarknaden just då. De flesta väljer att hyra utrustning några hopp tills de är säkra
                på att det är en sport de vill satsa på.</p>
        </Section>
        <Section id="risk" name="Risk"  >
            <SectionHeader >Risk</SectionHeader>
            <p>Fallskärmshoppning är en farlig sport men man kan minimera riskerna.
                För att göra det på ett säkert sätt krävs god förståelse av utrustning och utförande.
            </p>
            <p>Statiskt sett är skador ovanliga i fallskärmshoppning. Att en hoppare behöver använda sin
                reservfallskärm händer ungefär en
                gång per tusen hopp men när utfört korrekt medför det inte någon risk i sig självt. På en
                normal säsong händer flera reservdrag. Dödsolyckor är mycket ovanliga i Sverige och händer
                någonstans runt ett per 100 000 fallskärmshopp men med så sällsynta händelser så förändras
                statistiken helt utav en enda incident. De vanligaste skadorna är fot-,
                ankel- och knäskador. Den här manualen tillsammans med grundutbildningen ger dig information
                som hjälper dig att kunna fallskärm på ett säkert sätt.</p>
        </Section>
        <Section id="intro-quiz" name="Quiz"  >
            <SectionHeader >Quiz</SectionHeader>
            <p></p>

            <Questionary
                questions={introQuiz}
            />
        </Section>
    </Article>
);

export { Intro, introQuiz };